export const configureStyles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginBottom: "16px",
  },
  title: {
    display: "flex",
  },
  icon: {
    marginRight: "16px",
    transform: "scaleX(-1)",
  },
  text: {
    fontWeight: 500,
    fontSize: "22px",
    lineHeight: "27px",
    color: "#103B66",
  },
  middle: {
    marginBottom: "24px",
  },
  middlePerc: {
    color: "#FFA26B",
    marginBottom: "16px",
  },
  middleTitlePerc: {
    fontSize: "30px",
    marginBottom: "0px",
  },
  middleTitle: {
    fontSize: "15px",
  },
  middlePercDetails: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "22px",
    color: "#103B66",
  },
  bottom: {
    display: "flex",
    color: "#21B8F9",
  },
  bottomText: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "20px",
    textDecorationLine: "underline",
    marginRight: "12px",
    cursor: "pointer",
  },
};
